export default {
  spaceManagement: {
    title: 0,
    spaceSearchForm: {
      date: '',
      code: '',
      name: '',
      undertakerTel: '',
      fhId: 0,
      amUseDate: '',
      status: 0,
      updateState: 5,
      visitorFrozen: 0,
      spaceFrozen: 0,
      remarkName: '',
      appShortName: '',
      appShortNameChoice: '',
      appShortNameChoiceId: '',
      codeOrName:'',
      loginMobileState:null,
    },

    farewellOfficeList:[{
      areaName: '全部',
      areaId: 0,
    }],

    findAppInfoAllList: [],

    stateList: [{
      areaName: '全部',
      areaId: 0
    },{
      areaName: '有效',
      areaId: 1
    },{
      areaName: '过期',
      areaId: 2
    },{
      areaName: '冻结',
      areaId: 4
    },{
      areaName: '永久',
      areaId: 3
    }],

    changeStateList: [{
      areaName: '全部',
      areaId: 5
    },{
      areaName: '编辑中',
      areaId: 1
    },{
      areaName: '上传中',
      areaId: 2
    },{
      areaName: '编辑中-上传中',
      areaId: 3
    },{
      areaName: '无',
      areaId: 0
    }],

    pageManagementLog: {
      page: 1,
      size: 10,
      total: 0,
    },

    pageManagementAll: {
      page: 1,
      size: 10,
      total: 0,
    },

    pageManagementV: {
      page: 1,
      size: 10,
      total: 0,
    },

    pageManagementS: {
      page: 1,
      size: 10,
      total: 0,
    },

    totalList: [''],
    
    
    createForm:{
      name: '',
      undertakerName: '',
      undertakerTel: '',
      coverUrl:"",
      coverType:0,
      deadName: '',
      coverImages: [],
    },

    officeList: [],
    
    officeForm:{
      office: '',
      date: '',
      startTime: '',
      endTime: ''
    },

    number: '0条',

    spaceLogForm: {
      createUserName: '',
      content: '',
      date: ''
    },

    logList:[''],
    numberLog: "",
    loginMobileStateList: [
      { areaName: "全部", areaId: null },
      { areaName: "是", areaId: 1 },
      { areaName: "否", areaId: 0 },
    ],
  },

  spaceDetails:{
    pageManagement: {
      page: 1,
      size: 4,
      total: 0,
    },
    details:{},
    overUrlOld: '',
    spaceHomeForm: {
      name: '',
      sex: '',
      birthday: '',
      deadday: '',
      calendarState: '',
      birthdaySolar: '',
      birthdayLunar: '',
      deaddaySolar: '',
      deaddayLunar: ''
    },
    stateList: [
      { areaName: "男", areaId: 0 },
      { areaName: "女", areaId: 1 },
    ],
    calendarList: [
      { areaName: "公历", areaId: 1 },
      { areaName: "农历", areaId: 2 },
    ],
    leaveWordList:[''],
    leaveWordNumber: '',
    leaveWords: true,
    peopleList:[''],
    spacePeopleForm: {
      tel: '',
      nickName: '',
      name: '',
    },
    updateState: true,
    uploadState: true,
    isHaveCover: false,
    dataUploadState: true,
    spaceLogForm: {
      createUserName: '',
      content: '',
      date: ''
    },
    numberLog: "",
    logList:[''],
    pageManagementLog: {
      page: 1,
      size: 9,
      total: 0,
    },

    qrcodeVisible: false,
    qrcodeVisibleDown: false,
    qrcodeVisibleClaimApp: false,
    qrcodeVisibleClaimAll: false,
    qrcodeVisibleClaim: false,
    qrcodeVisibleDownClaimApp: false,
    qrcodeVisibleDownClaimAll: false,
    qrcodeVisibleDownClaim: false,
    showOrdown: 0,
    showBgUrl: '',
    fontColor: '',
    freezingVisitorDialog: false,
    unfreezeDialog: false,
    visitorFrozenContentNew: '',
    visitorFrozenContent: '',

    showOrdownCode: 0,
    showBgUrlCode: '',
    fontColorCode: '',
    photoAlbumDialog: false,
    photoCategoryList:[],


    photoAlbumData: {
      name:'',
      lookPms: '0',
      coverUrl: '',
      photoCreated: true,
    },

    photoAlbumDetails: {
      show:false,
      name: '',
      categoryId: '',
    },

    updateFileList:[],

    pageInfo: {
      page: 1,
      size: 50,
      total: 0
    },
    isCanNext: true,
    isCanUpdate: false,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/SpaceManagement/state.js